import { render, staticRenderFns } from "./VendorUsers.vue?vue&type=template&id=83d7775a"
import script from "./VendorUsers.vue?vue&type=script&lang=js"
export * from "./VendorUsers.vue?vue&type=script&lang=js"
import style0 from "./VendorUsers.vue?vue&type=style&index=0&id=83d7775a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports